//main.js

window.dataLayer = window.dataLayer || [];

	var supplierSliderOptions = {
		minSlides: 1,
		maxSlides: 1,
		slideWidth: 250,
		touchEnabled: false,
		infiniteLoop: true,
		auto: true,
		autoHover: true,
		pause: 8000,
		controls: false,
		pager: false
	};

	$(".monthList").bxSlider({
		minSlides: 1,
		maxSlides: 4,
		nextText: ">",
		prevText: "<",
		slideWidth: 100,
		infiniteLoop: false,
		pager: false
	});


	//toggle mobile nav, and it's children slider
	$(".navToggle").click(function(e) {
		e.preventDefault();
		$("body").toggleClass("navOpen");
	});



	$(".childToggle").click(function(e) {
		e.preventDefault();
		$(this).next(".dropdown").slideToggle(250);
	});


	//JS to toggle active classes on homepage interactive callout items
	$(".mainCallouts > div").hover(
		function() {
			if ( $(window).width() > 1000 ) {
				$(this).addClass("active").siblings().addClass("inactive");
			}
		}, function() {
			if ( $(window).width() > 1000 ) {
				$(".mainCallouts > div").removeClass("active inactive");
			}
		}
	);


	$(".featured li").hover(function() {
		if ( $(window).width() > 1000 ) {

			$(".featured li").stop().animate({width: "22%"}, 250);
			$(this).stop().animate({width: "33.6%"}, 250);

		}
	});


	$( window ).resize(function() {
		$(".featured li").css('width', '');
	});

	//JS to toggle active classes on homepage featured bar
	$(".featured ul").hover(
		function() {
		}, function() {
			if ( $(window).width() > 1000 ) {
				$(".featured li").stop().animate({width: "24.9%"}, 250);
			}
		}
	);


	//start the searching
	$(".searchToggle").click(function(e) {
		e.preventDefault();

		$("body").addClass("searchOverlay");

		setTimeout(function(){
			$("#searchForm").addClass('active');
		},10);

		$("#searchInput").focus();
	});
	$(".searchClose").click(function(e) {
		e.preventDefault();

		$("#searchForm").removeClass('active');

		setTimeout(function(){
			$("body").removeClass("searchOverlay");
		},250);
	});


	//newsletter
	$(".newsletterToggle").click(function(e) {
		e.preventDefault();

		$("body").addClass("newsletterOverlay");

		setTimeout(function(){
			$("#newsletterForm").addClass('active');
		},10);
	});


	$(".newsletterClose").click(function(e) {

		e.preventDefault();

		$("#newsletterForm").removeClass('active');

		setTimeout(function(){
			$("body").removeClass("newsletterOverlay");
		},250);
	});


	//pop sharing button targets in popup window
	$(".resp-sharing-button__link").click(function(e) {
		e.preventDefault();
		var width = 550;
		var height = 450;
		var url = $(this).attr("href");
		window.open( url, "myWindow", "status = 1, height = " + height + ", width = " + width + ", resizable = 0" );
	});


	//tabs & accordions
	$(".tabs-title a").click(function(e) {
		e.preventDefault();
		if ( !$(this).parent().is(".active") ) {
			$(".room-configs .tabs .tabs-title").each(function() {
				$(this).removeClass("active").find("a").attr("aria-selected", "false");
			});
			var slug = $(this).attr("href");
			$(".room-configs .tabs-content .content").removeClass("active").attr("aria-hidden", "true");
			$(this).attr("aria-selected", "true").parent().addClass("active");
			$(slug).addClass("active").attr("aria-hidden", "false")
		}
	});
	$(".accordion .title a").click(function(e) {
		e.preventDefault();
		$(this).parent().next(".content").slideToggle();
		$(this).toggleClass('active');
	});


	//animated scroll to id
	$(".scrollLink").click(function(e) {
		e.preventDefault();
		var target = $(this).attr("href");
		var padding = 90;
		if (window.innerWidth > 640) {
			var padding = 20;
		}
		$('html, body').animate({
			scrollTop: $(target).offset().top - padding
		}, 500);
	});


	//image modals
	$('.image-popup').magnificPopup({type:'image'});


	//video modals
	$('.video-popup').each(function() {
		var videoSrc = $(this).data("video-src");
		$(this).magnificPopup({
			items: {
				src: videoSrc
			},
			type: 'iframe'
		});
	});

	//inline video
	$(".video").fitVids();


	//pop video on click
	$('.videoModal').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false
	});


	// form modals
	$('.popupWithForm').magnificPopup({
		type: 'inline',
		preloader: false,
		focus: '#name',
		closeBtnInside: false,

		// When elemened is focused, some mobile browsers in some cases zoom in
		// It looks not nice, so we disable it:
		callbacks: {
			beforeOpen: function() {
				if ($(window).width() < 700) {
					this.st.focus = false;
				} else {
					this.st.focus = '#name';
				}
			}
		}
	});


	var timer5s
	var timer10s

	//tracking code for hover of people
	$("#contactPage .memberList li").mouseenter(function() {

		var $personElement = $(this);
		var personPhone = $personElement.find(".personPhone").text();
		var personName = $personElement.find(".personName").text();

		if ( !$personElement.hasClass("submitted") ) {

			timer5s = setTimeout(function(){

				dataLayer.push({
					'event': 'contactHover',
					'eventCategory': 'Contact',
					'eventAction': 'phone 5s',
					'eventLabel': personPhone + ' (' + personName + ')'
				});

			}, 5000);

			timer10s = setTimeout(function(){

				$personElement.addClass("submitted");

				dataLayer.push({
					'event': 'contactHover',
					'eventCategory': 'Contact',
					'eventAction': 'phone 10s',
					'eventLabel': personPhone + ' (' + personName + ')'
				});

			}, 10000);
		}

	}).mouseleave(function() {

		clearTimeout(timer5s);
		clearTimeout(timer10s);

	});


	//pop BOD bios on click
	$('.memberList').magnificPopup({
		delegate: '.bioToggle',
		removalDelay: 500, //delay removal by X to allow out-animation
		callbacks: {
			beforeOpen: function() {
				//blur to fix sticking CSS hover issue
				$('.memberList .bioToggle').each(function() {
					$(this).blur();
				});

				this.st.mainClass = this.st.el.attr('data-effect');
			}
		},
		midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
	});

/*
// Split Full name into First and Last name
	function splitFullName() {

		var $fullname = $('#FullName').val(),
				fullnameSplit,
				fname,
				lname;

		if($fullname) {
			fullnameSplit = $fullname.split(' ');

			fname = fullnameSplit.slice(0, -1).join(' ');
			lname = fullnameSplit.slice(-1).join(' ');

			if(!fname) {
				fname = lname;
				$('#mce-FNAME').val(fname);
			} else {
				$('#mce-FNAME').val(fname);
				$('#mce-LNAME').val(lname);
			}

		}
	}

	$('#mc-embedded-subscribe-form').submit(function(e){
		splitFullName();
	});

	//mailchimp
	function mcCallback (resp) {
		if (resp.result === 'success') {

		  $('#mc-embedded-subscribe-form').fadeOut(500, function() {
			$(this).html('<div class="success"><p><strong>Thank you for subscribing.</strong></p><p>Please check your email to confirm your subscription.</p></div>').fadeIn(500);
		  });

			dataLayer.push({
				'event': 'formSubmission',
				'formType': 'Newsletter Signup'
			});
		} else {

			var errorMsg,
				errorOutput;

			if(resp.msg == '0 - Please enter a value' || resp.msg == 'Blank email address') {
				errorMsg = "Please enter your email address.";
			} else if(resp.msg == '0 - An email address must contain a single @' || resp.msg == '0 - The domain portion of the email address is invalid (the portion after the @: )') {
				errorMsg = "Please enter a valid email address.";
			} else {
				errorMsg = resp.msg;
			}

			errorOutput = '<div class="error">' + errorMsg + '</div>';

			$('#mc-embedded-subscribe-form').find("div.error").remove();
			$('#mc-embedded-subscribe-form').prepend(errorOutput);
		}
	}
	$('#mc-embedded-subscribe-form').ajaxChimp({
		callback: mcCallback
	});
*/

	function makeInline(elem) {
		var $img = $(elem);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		$.get(imgURL, function(data) {
			var $svg = $(data).find('svg');
			if (typeof imgID !== 'undefined') {
				$svg = $svg.attr('id', imgID);
			}
			if (typeof imgClass !== 'undefined') {
				$svg = $svg.attr('class', imgClass+' replaced-svg');
			}
			$svg = $svg.removeAttr('xmlns:a');
			$img.replaceWith($svg);
		}, 'xml');
	}
	//convert linked SVG to inline where needed for colouring
	$('.makeInline img').each(function() {
		makeInline(this);
	});


	// WHAT'S HAPPENING
	$(".tagToggle").click(function(e) {
		e.preventDefault();
		$(this).parent().find(".tagList").find(".toggleable").css("display", "inline-block");
		$(this).hide();
	});

	function convert_video(input) {
	  var pattern = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(\S+)/g;
	  if (pattern.test(input)) {
	   var replacement = 'https://player.vimeo.com/video/$1?title=0&byline=0&portrait=0&color=D11D5F';
	   return input = input.replace(pattern, replacement);
	  }
	  var pattern = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(\S+)/g;
	  if (pattern.test(input)) {
	    var replacement = 'https://www.youtube.com/embed/$1?rel=0&modestbranding=1';
	    return input = input.replace(pattern, replacement);
	  }

	}

	// VIDEO CONTENT BLOCK
	$(document).on('click', '.videoitem a', function(e) {
		e.preventDefault();
		var $elem = $(this);
		var $container = $elem.parents('.videoblock').find('.videofeature');
		$container.find('.videotitle').html($elem.attr('data-title'));
		$container.find('.videodescription').html($elem.attr('data-description'));
		var iframe = convert_video($elem.attr('data-video'));
		$container.find('.videoiframe').attr('src',iframe);
		if (window.innerWidth < 1024) {
			$('html, body').animate({
				scrollTop: ($container.offset().top - $('#header').height())
			},500);
		}
	});

	$('.videoslider').bxSlider({
		minSlides: 1,
		maxSlides: 4,
		nextText: ">",
		prevText: "<",
		slideWidth: 227,
		infiniteLoop: false,
		pager: false
	});


	$(".tabToggle").click(function(e) {
		e.preventDefault();

		var pagePath = window.location.pathname;
		var target = $(this).attr("href");

		window.history.pushState('Tab', 'Tab', window.location.pathname + "?tab=" + target.substring(1));

		$(".tabSubNav li").removeClass("active");
		$(this).parent().addClass("active");

		$(".pageTab").removeClass("active");
		$("" + target).addClass("active");
	});

	$("#contactTabLink").click(function(e) {

		e.preventDefault();
		$("#contactTabFormContainer").toggleClass("active");

	});


	$(".contactClose").click(function(e) {
		e.preventDefault();
		$('#contactTabFormContainer').toggleClass("active");
	});


	$(".tourToggle").click(function(e) {
		e.preventDefault();

		var $iFrame = $("#tourFrame");
		var frameAddress = $(this).attr("href");

		if (!$iFrame.hasClass("loaded")) {
			$iFrame.attr("src", frameAddress);
			$iFrame.addClass("loaded");
		}

		if ($("#tourOverlay").is(":visible")) {

			$("#tourOverlay").removeClass('active');

			setTimeout(function(){
				$("#tourOverlay").hide();
			},10);

		} else {

			$("#tourOverlay").show();

			setTimeout(function(){
				$("#tourOverlay").addClass('active');
			},10);

		}
	});

	$(".closeMessage").click(function(e) {
		e.preventDefault();

		$(".message").fadeOut();

	});


	//sticky elements on scroll
	var $contactElement = $("#contactTab");
	var contactToggleDistance = 240;

	$(window).scroll(function() {

		if ($(document).scrollTop() > contactToggleDistance && !$contactElement.hasClass("minimized")) {
			$contactElement.addClass("minimized");
		} else if ($(document).scrollTop() <= contactToggleDistance && $contactElement.hasClass("minimized")) {
			$contactElement.removeClass("minimized");
		}

	});
